// extracted by mini-css-extract-plugin
export default {"quizHistoryContainr":"MyAcademics_quizHistoryContainr__NfLA-","accordianStyle":"MyAcademics_accordianStyle__CmXkR","accordianTitle":"MyAcademics_accordianTitle__0vD3P"};